//个人信息查询
import axios from 'axios';
import isJsonStr from "../../utils/modules/isJsonStr";

/*
  个人信息获取:
  dwzh: 单位账号
  page: 页数
  count: 每页总数
  name: 姓名
  code: 身份证号码
  grzh: 个人账号
*/

function getUserList(obj={}) {
  let dwzh = obj.dwzh;
  let page = obj.page || 1;
  let count = obj.count || 10;
  let name = obj.name || '';
  let code = obj.code || '';
  let grzh = obj.grzh || '';
  let grzhzt = obj.grzhzt || '';

  return new Promise((resolve, reject) => {
    axios.post('/ej-isp-api/zk/ywcx/grjbxxcx', {}, {
      data: {
        para:{
          "jydm":"2001",
          "extParam":{
            "dwzh":dwzh,
            "page":page,
            "count":count,
            "grzhs":[{
              "grzh":grzh,
              "xingming":name,
              "zjhm":code,
              "grzhzt":grzhzt
            }]
          }
        }
      }
    }).then(res => {
      resolve(res.data);
    }).catch((err => {
      reject(err);
    }))
  })
}

/*个人账户信息*/
function getUserZhxx(obj={},yhlx=2) {
  let dwzh = obj.dwzh;
  let grzh = obj.grzh || '';
  let page = obj.page || 1;
  let count = obj.count || 10;

  return new Promise((resolve, reject) => {
    axios.post('/ej-isp-api/zk/ywcx/grzhxxcx', {}, {
      data: {
        para:{
          "qqly": 2,
          "yhlx": yhlx,
          "jydm":"2102",
          "extParam":{
            "dwzh":dwzh,
            "page":page,
            "count":count,
            "grzh":grzh
          }
        }
      }
    }).then(res => {
      resolve(res.data);
    }).catch((err => {
      reject(err);
    }))
  })
}

/**
 * 个人账户信息-优化版
 * @param obj
 * @param yhlx
 * @returns {Promise<unknown>}
 */
function getUserZhxxFn(obj={},yhlx=2) {
  let dwzh = obj.dwzh;
  let grzh = obj.grzh || '';
  let page = obj.page || 1;
  let count = obj.count || 10;

  return new Promise((resolve, reject) => {
    axios.post('/ej-isp-api/zk/ywcx/grzhxxcx', {}, {
      data: {
        para:{
          "qqly": 2,
          "yhlx": yhlx,
          "jydm":"2102",
          "extParam":{
              dwzh,
              page,
              count,
              grzh
          }
        }
      }
    })
        .then(({ data:res }) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result[0])
                } else {
                    throw { message: data.msg.map(item => item.cwxx).join('<br>') || data.message }
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
  })
}

//个人业务明细
function getUserGrywmxcx(obj={},yhlx=2) {
  let dwzh = obj.dwzh;
  let grzh = obj.grzh || '';
  let ywlsh = obj.ywlsh || '';
  let ksrq = obj.ksrq || '';
  let jsrq = obj.jsrq || '';
  let page = obj.page || 1;
  let count = obj.count || 10;

  return new Promise((resolve, reject) => {
    axios.post('/ej-isp-api/zk/ywcx/grywmxcx', {}, {
      data: {
        para:{
          "qqly": 2,
          "yhlx": yhlx,
          "jydm":"2002",
          "extParam":{
            "dwzh":dwzh,
            "grzh":grzh,
            "ywlsh":ywlsh,
            "ksrq":ksrq,
            "jsrq":jsrq,
            "page":page,
            "count":count,
          }
        }
      }
    }).then(res => {
      resolve(res.data);
    }).catch((err => {
      reject(err);
    }))
  })
}

export {
  getUserList,
  getUserGrywmxcx,
    getUserZhxxFn,
  getUserZhxx
}



// WEBPACK FOOTER //
// ./src/static/js/api/user/index.js